import * as React from 'react';
import { Link } from 'react-router-dom';

class StartComponent extends React.Component {
  render() {

    return (
      <div className="container">
        <div className="gap-50"/>
        <div className="row">
          <div className="col-sm-6 text-center">
            <div className="card-primary">
              <h4 className="f-w-100">
                Invierte en negocios ambiciosos
              </h4>
              <p>
                Accede a las mejores oportunidades de inversión, invierte en negocios en los que crees y forma parte de
                su éxito.
              </p>
              <div className="gap-20"/>
              <Link
                to="/como-invertir"
                className="btn btn-secondary btn-lg"
              >
                Empieza a invertir
              </Link>
            </div>
          </div>
          <div className="col-sm-6 text-center">
            <div className="card-primary-dark">
              <h4 className="f-w-100">
                Consigue financiación de manera inteligente
              </h4>
              <p>
                Capta inversión de manera rápida, con inversores de calidad y con una ronda de financiación estructurada
                 profesionalmente.
              </p>
              <div className="gap-20"/>
              <Link
                to="/como-financiar-tu-startup"
                className="btn btn-primary btn-lg"
              >
                Contacta con nosotros
              </Link>
            </div>
          </div>
        </div>
        <div className="gap-50"/>
      </div>
    );
  }
}

export default StartComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/start/Start.component.tsx